import { render, staticRenderFns } from "./Add_project.vue?vue&type=template&id=c8015f10&scoped=true&"
import script from "./Add_project.vue?vue&type=script&lang=js&"
export * from "./Add_project.vue?vue&type=script&lang=js&"
import style0 from "./Add_project.vue?vue&type=style&index=0&id=c8015f10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8015f10",
  null
  
)

export default component.exports